import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import * as api from '../../services/api';
import { AuthPageShell, fieldClass, primaryButtonClass } from './AuthPageShell';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [pending, setPending] = useState(false);
  const [sent, setSent] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setPending(true);
    try {
      // The backend always responds 202 regardless of whether the email
      // exists, to avoid user enumeration — so there is nothing
      // meaningful to branch on here beyond "request sent".
      await api.requestPasswordReset(email);
    } finally {
      setPending(false);
      setSent(true);
    }
  }

  if (sent) {
    return (
      <AuthPageShell title="Sjekk e-posten din" lead="">
        <p className="text-sm text-black/70">
          Hvis e-postadressen finnes i systemet vårt, har vi sendt instruksjoner for å tilbakestille passordet.
          Lenken er gyldig i 1 time.
        </p>
        <Link to="/login" className="mt-6 inline-block text-sm font-medium text-[var(--brand-primary,#4338ca)]">
          Tilbake til innlogging
        </Link>
      </AuthPageShell>
    );
  }

  return (
    <AuthPageShell title="Glemt passord" lead="Skriv inn e-postadressen din, så sender vi deg en lenke for å tilbakestille passordet.">
      <form onSubmit={submit} className="space-y-5">
        <label className="block text-sm font-medium">
          E-post
          <input
            className={fieldClass}
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </label>
        <button className={primaryButtonClass} disabled={pending} type="submit">
          {pending ? 'Sender…' : 'Send tilbakestillingslenke'}
        </button>
      </form>
      <Link to="/login" className="mt-4 block text-center text-xs text-black/45">
        Tilbake til innlogging
      </Link>
    </AuthPageShell>
  );
}
